import { Modal, Box, CircularProgress } from '@mui/material';

const TEXT_BODY = '#3b4a63';
const ACCENT_ORANGE = '#d96c3c';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 220,
    bgcolor: '#fff',
    borderRadius: '14px',
    boxShadow: '0 8px 32px rgba(12, 61, 110, 0.14)',
    padding: '28px 32px',
};

function CircularLoadingPopUp() {
    return (
        <div>
            <Modal open={true}>
                <Box sx={style}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <CircularProgress size={28} sx={{ color: ACCENT_ORANGE }} />
                        <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: TEXT_BODY }}>
                            Loading...
                        </p>
                    </Box>
                </Box>
            </Modal>
        </div>
    )
}

export default CircularLoadingPopUp